import { Box } from '@mui/material';
import { User } from '../../../utils';
import ContactInformationPreviewItem from './contact-information-preview-item';
import { useTranslation } from 'react-i18next';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Button from '../../../../../components/button';

interface ContactInformationPreviewProps {
    user: User;
    togglePreview: () => void;
    showProducts: boolean;
    products: string;
}
const ContactInformationPreview = ({ user, togglePreview, showProducts, products }: ContactInformationPreviewProps) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ maxWidth: 544 }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
                <Button icon={EditOutlinedIcon} variant='text' onClick={togglePreview} />
            </Box>
            <ContactInformationPreviewItem label={t('first-name')} title={user.firstName} />
            <ContactInformationPreviewItem label={t('last-name')} title={user.lastName} />
            <ContactInformationPreviewItem label={t('title')} title={user.title} />
            <ContactInformationPreviewItem label={t('email')} title={user.email} />
            <ContactInformationPreviewItem label={t('phone-number')} title={user.phoneNumber} />
            {showProducts && <ContactInformationPreviewItem label={t('assigned-products')} title={products} />}
        </Box>
    );
};

export default ContactInformationPreview;
